import React, { useEffect, useState, useRef } from "react";
import { useObjectList } from "./useObjectList";
import styles from "./placeArtMenu.scss";
import { Sidebar } from "../sidebar/Sidebar";
import { CloseButton } from "../input/CloseButton";
import configs from "../../utils/configs";

export function ArtworkSidebar({ close, open }) {
  const apiUrl = configs.CUSTOM_API_URL;
  const [qrCode, setQR] = useState(null);
  const [artworkInfo, setArtworkInfo] = useState({});
  const { objects, selectedObject, toggleLights } = useObjectList();

  const onClose = () => {
    close();
  };

  const setQRArtwork = () => {
    const qrEl = selectedObject.el.querySelector("[artwork-qr]");
    if (qrEl) {
      const qrArtwork = qrEl.components["artwork-qr"]?.qrCodeUrl;
      if (qrArtwork) setQR(qrArtwork);
    }
  };

  useEffect(() => {
    const artworkEl = selectedObject?.el;
    if (!artworkEl) return;

    setArtworkInfo(selectedObject.el.components.artwork?.data?.artworkInfo);
    if (open && artworkInfo) {
      setQRArtwork();
    }
  }, [open]);

  return (
    <>
      {open && (
        <Sidebar
          className={styles.placeartSidebar}
          headerClassName={styles.placeartSidebarHeader}
          afterTitle={<CloseButton className={styles.close} onClick={onClose} />}
        >
          <div className={styles.artworkLabelContainer}>
            <h2 className="author">{artworkInfo.author}</h2>
            <p className="date">{artworkInfo.artworkDate}</p>
            <p className="title">{artworkInfo.title}</p>
            <p className="medium">{artworkInfo.medium}</p>
            <p className="dimensions">{artworkInfo.dimensions}</p>
            <p className="description">{artworkInfo.description}</p>
            <p className="description">{artworkInfo.artistStatement}</p>

            {qrCode && (
              <div className="qr">
                <img src={qrCode}></img>
                <span>See on AR or VR!</span>
              </div>
            )}
          </div>
        </Sidebar>
      )}
    </>
  );
}
